// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3-dQ9","resendInfoText":"OnGoingPaymentBox_resendInfoText__mOVxm"};